const STORAGE_SESSION_KEY = "cargogo-storage-session";

export function getStorageSessionId(): string | null {
  if (typeof sessionStorage === "undefined") {
    return null;
  }
  return sessionStorage.getItem(STORAGE_SESSION_KEY);
}

export function getOrCreateStorageSessionId(): string {
  if (typeof sessionStorage === "undefined") {
    return "ssr";
  }
  const existing = sessionStorage.getItem(STORAGE_SESSION_KEY);
  if (existing) {
    return existing;
  }
  const id = crypto.randomUUID();
  sessionStorage.setItem(STORAGE_SESSION_KEY, id);
  return id;
}

/** Invalidate cached persist data from a previous login / account. */
export function rotateStorageSessionId(): string {
  if (typeof sessionStorage === "undefined") {
    return "ssr";
  }
  const id = crypto.randomUUID();
  sessionStorage.setItem(STORAGE_SESSION_KEY, id);
  return id;
}

export function buildSessionScope(userId?: string, companySeqNumber?: number): string {
  if (!userId) {
    return "guest";
  }
  return `${userId}:${companySeqNumber ?? 0}`;
}

if (typeof sessionStorage !== "undefined" && !sessionStorage.getItem(STORAGE_SESSION_KEY)) {
  sessionStorage.setItem(STORAGE_SESSION_KEY, crypto.randomUUID());
}
